<script lang="ts">
    import { mdiEmailMultipleOutline, mdiPhoneOutline } from "@mdi/js"
    import Icon from "./Icon.svelte"
    import { onDestroy, onMount } from "svelte"

    const arrowUp =
        "M11.9999 12C11.8579 12 11.7389 11.952 11.6429 11.856C11.5469 11.76 11.4993 11.6413 11.4999 11.5V4.86399L6.67694 9.67999C6.58361 9.77332 6.47294 9.81799 6.34494 9.81399C6.21761 9.80932 6.10428 9.75832 6.00494 9.66099C5.91294 9.57099 5.86694 9.45699 5.86694 9.31899C5.86694 9.18099 5.91361 9.06532 6.00694 8.97199L11.4349 3.54499C11.5216 3.45832 11.6116 3.39732 11.7049 3.36199C11.7983 3.32666 11.8973 3.30899 12.0019 3.30899C12.1066 3.30899 12.2053 3.32666 12.2979 3.36199C12.3906 3.39732 12.4799 3.45832 12.5659 3.54499L18.0119 8.99099C18.1053 9.08166 18.1519 9.19499 18.1519 9.33099C18.1519 9.46699 18.1053 9.58332 18.0119 9.67999C17.9146 9.78999 17.7956 9.84199 17.6549 9.83599C17.5149 9.82932 17.3959 9.77732 17.2979 9.67999L12.4999 4.88299V11.5C12.4999 11.642 12.4519 11.7607 12.3559 11.856C12.2599 11.9513 12.1409 11.9993 11.9989 12M11.9989 17C11.8576 17 11.7389 16.952 11.6429 16.856C11.5469 16.76 11.4993 16.6413 11.4999 16.5V14.5C11.4999 14.358 11.5479 14.2393 11.6439 14.144C11.7399 14.0487 11.8589 14.0007 12.0009 14C12.1429 13.9993 12.2616 14.0473 12.3569 14.144C12.4523 14.2407 12.4999 14.3593 12.4999 14.5V16.5C12.4999 16.642 12.4519 16.7607 12.3559 16.856C12.2599 16.9513 12.1409 16.9993 11.9989 17ZM11.9989 21C11.8576 21 11.7389 20.952 11.6429 20.856C11.5469 20.76 11.4993 20.6413 11.4999 20.5V19.5C11.4999 19.358 11.5479 19.2393 11.6439 19.144C11.7399 19.0487 11.8589 19.0007 12.0009 19C12.1429 18.9993 12.2616 19.0473 12.3569 19.144C12.4523 19.2407 12.4999 19.3593 12.4999 19.5V20.5C12.4999 20.642 12.4519 20.7607 12.3559 20.856C12.2599 20.9513 12.1409 20.9993 11.9989 21Z"

    let showScroll = false

    const checkScroll = () => {
        // Change the visibility of the button based on the scroll position
        showScroll = window.pageYOffset > 200
    }

    const scrollToTop = () => {
        if (typeof window !== "undefined") {
            // Scroll smoothly to the top
            window.scrollTo({ top: 0, behavior: "smooth" })
        }
    }

    onMount(() => {
        if (typeof window !== "undefined") {
            // Attach scroll event listener when component is mounted
            window.addEventListener("scroll", checkScroll)
        }
    })

    onDestroy(() => {
        if (typeof window !== "undefined") {
            // Remove scroll event listener when component is destroyed
            window.removeEventListener("scroll", checkScroll)
        }
    })

    const sidebar = [
        {
            mailText: "kanzlei[at]rechtec.de",
            mailLink: "mailto:kanzlei@rechtec.de",
            phoneText: "+49 (0)361-789 298 65",
            phoneLink: "tel:+4936128929865",
            country: "Germany",
        },
    ]
</script>

<aside>
    <ul>
        {#each sidebar as item}
            <li>
                <button>
                    <span class="icon">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="36"
                            height="36"
                            viewBox="0 0 36 36"
                            fill="none"
                        >
                            <path
                                d="M17.9437 1.125C10.575 1.125 4.33124 5.85 2.02499 12.375H33.8625C31.5562 5.85 25.3125 1.125 17.9437 1.125Z"
                                fill="#3E4347"
                            ></path>
                            <path
                                d="M17.9437 34.875C25.3125 34.875 31.5562 30.2062 33.8625 23.625H2.02499C4.33124 30.2062 10.575 34.875 17.9437 34.875Z"
                                fill="#FFE62E"
                            ></path>
                            <path
                                d="M2.02501 12.375C1.40626 14.1187 1.06876 16.0312 1.06876 18C1.06876 19.9688 1.40626 21.8813 2.02501 23.625H33.8625C34.4813 21.8813 34.8188 19.9688 34.8188 18C34.8188 16.0312 34.4813 14.1187 33.8625 12.375H2.02501Z"
                                fill="#ED4C5C"
                            ></path>
                        </svg>
                    </span>
                    <span class="text {item.country}">
                        <a href="{item.mailLink}"
                            ><svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                            >
                                <path
                                    d="M6.616 16.77C6.15533 16.77 5.771 16.6156 5.463 16.307C5.155 15.9983 5.00067 15.614 5 15.154V5.38398C5 4.92398 5.15433 4.53998 5.463 4.23198C5.77167 3.92398 6.156 3.76965 6.616 3.76898H20.385C20.845 3.76898 21.2293 3.92332 21.538 4.23198C21.8467 4.54065 22.0007 4.92498 22 5.38498V15.154C22 15.614 21.846 15.9983 21.538 16.307C21.23 16.6156 20.8457 16.7696 20.385 16.769L6.616 16.77ZM13.021 11.17L6 5.94298V15.153C6 15.3323 6.05767 15.4796 6.173 15.595C6.28833 15.7103 6.436 15.768 6.616 15.768H20.385C20.5643 15.768 20.7117 15.7103 20.827 15.595C20.9423 15.4796 21 15.3323 21 15.153V5.94298L13.979 11.168C13.8337 11.276 13.674 11.33 13.5 11.33C13.326 11.33 13.1663 11.276 13.021 11.168M13.5 10.311L20.808 4.88398C20.7693 4.84531 20.7277 4.81632 20.683 4.79698C20.6377 4.77765 20.5767 4.76798 20.5 4.76798H6.5C6.436 4.76798 6.372 4.78398 6.308 4.81598C6.244 4.84798 6.19267 4.88332 6.154 4.92198L13.5 10.311ZM3.616 19.768C3.15533 19.768 2.771 19.614 2.463 19.306C2.155 18.998 2.00067 18.614 2 18.154V9.15398C2 9.01132 2.04767 8.89231 2.143 8.79698C2.23833 8.70165 2.35733 8.65398 2.5 8.65398C2.64267 8.65398 2.76167 8.70165 2.857 8.79698C2.95233 8.89231 3 9.01132 3 9.15398V18.154C3 18.3333 3.05767 18.4806 3.173 18.596C3.28833 18.7113 3.436 18.769 3.616 18.769H17.885C18.027 18.769 18.1457 18.8166 18.241 18.912C18.3363 19.0073 18.3843 19.1263 18.385 19.269C18.3857 19.4116 18.3377 19.5306 18.241 19.626C18.1443 19.7213 18.0257 19.769 17.885 19.769L3.616 19.768ZM21 5.92698C21 5.74232 20.9777 5.55898 20.933 5.37698C20.8877 5.19498 20.846 5.03098 20.808 4.88498C20.7693 4.84632 20.7277 4.81632 20.683 4.79698C20.6377 4.77765 20.5767 4.76798 20.5 4.76798H6.5C6.436 4.76798 6.372 4.78398 6.308 4.81598C6.244 4.84798 6.19267 4.88332 6.154 4.92198C6.11533 5.06865 6.08 5.23065 6.048 5.40598C6.016 5.58132 6 5.75498 6 5.92698V4.76898H21V5.92698Z"
                                    fill="#F4F5F6"
                                ></path>
                            </svg>
                            {item.mailText}
                        </a>
                        <a href="{item.phoneLink}">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                            >
                                <path
                                    d="M19.2 20H20V15.587L16.25 14.831L13.638 17.539C12.7793 17.0657 12.0143 16.5857 11.343 16.099C10.6717 15.6123 10.069 15.089 9.535 14.529C9.00567 14.0037 8.49667 13.4137 8.008 12.759C7.51933 12.1057 7.047 11.3833 6.591 10.592L9.286 8.082L8.438 4H4V4.8C4 6.58 4.418 8.38067 5.254 10.202C6.09 12.0233 7.26433 13.697 8.777 15.223C10.303 16.749 11.9713 17.9267 13.782 18.756C15.5927 19.5853 17.3987 20 19.2 20ZM6.121 9.654C5.76833 8.86133 5.49933 8.078 5.314 7.304C5.12733 6.53067 5.02467 5.76267 5.006 5H7.634L8.214 7.735L6.121 9.654ZM14.571 17.988L16.611 15.909L19 16.385V18.989C18.218 18.9777 17.438 18.8853 16.66 18.712C15.8827 18.5393 15.1863 18.2973 14.571 17.988Z"
                                    fill="#F4F5F6"
                                ></path>
                            </svg>
                            {item.phoneText}
                        </a>
                    </span>
                </button>
            </li>
        {/each}
    </ul>
    <button
        style="max-width: 36px;"
        on:click="{() => {
            scrollToTop()
        }}"
        class:hide="{!showScroll}"
    >
        <Icon path="{arrowUp}" size="24px" />
    </button>
</aside>

<style lang="less">
    @import "../../css/variables.less";
    aside {
        position: fixed;
        z-index: 9999;
        right: 48px;
        height: calc(50vh - 48px);
        top: 50vh;

        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-end;

        button {
            min-width: 36px;
            color: var(--bg-grey-100);
            height: 36px;
            background-color: var(--grey-100);
            border-radius: 200px;
            display: flex;
            justify-content: center;
            align-items: center;
            transition: background-color 0.3s;
            border: none;
            &:hover {
                background-color: var(--orange-100);
            }
            &.hide {
                display: none;
            }
        }
        ul {
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            gap: 12px;
            @media @mobile {
                opacity: 0;
                pointer-events: none;
            }
            button {
                .icon {
                    height: 36px;
                }
                .text {
                    transition: width 1s;
                    width: 0px;
                    height: 100%;
                    overflow: hidden;
                    white-space: nowrap;
                    display: flex;
                    align-items: center;
                    overflow: hidden;
                    color: var(--bg-grey-100);
                    height: 100%;
                    gap: 10px;
                    font-size: 14px;

                    a {
                        color: var(--bg-grey-100);
                        height: 100%;
                        display: flex;
                        gap: 10px;
                        align-items: center;
                        white-space: nowrap;
                        padding-right: 12px;
                        &:first-of-type {
                            border-right: 1px solid white;
                        }
                    }
                }
                width: 36px;
                &:hover {
                    gap: 10px;
                    width: unset;
                    .icon {
                        transform: translate(-5px, 0px);
                    }
                    .text {
                        &.Germany {
                            width: 370px;
                        }

                    }
                }
            }
        }
    }
</style>
